import { useHMSScreenSharing } from "../hms";
import { useLivekitScreenSharing } from "../livekit";
import type { ProviderScreenSharing } from "../types";
import { useProviderHook } from "./useProviderHook";

export const useProviderScreenSharing = (
  canOverride = false,
): ProviderScreenSharing =>
  useProviderHook({
    hms: useHMSScreenSharing,
    livekit: useLivekitScreenSharing,
  })(canOverride);
